export default __webpack_public_path__ + "static/media/webpay.dedca173.png";